module.exports = __webpack_public_path__ + "img/day11.702281c2.jpeg";